@if (outerContent() || innerContent()) {
  @if (outerContent()) {
    <ui-form-field-addon-details [addon]="outerContent()" [position]="position()" role="outer" />
  }

  @if (innerContent()) {
    <ui-form-field-addon-details [addon]="innerContent()" [position]="position()" />
  }
}
